import { useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { createApp, updateApp } from "../../../store/slices/appSlice";

const validationSchema = Yup.object({
  station_name: Yup.string()
    .required("Station name is required")
    .min(3, "Minimum 3 characters")
    .max(100, "Maximum 100 characters"),
  app_name: Yup.string()
    .required("App name is required")
    .min(3, "Minimum 3 characters")
    .max(100, "Maximum 100 characters"),
  alias: Yup.string()
    .required("Alias is required")
    .min(3, "Minimum 3 characters")
    .max(100, "Maximum 100 characters"),
  Project: Yup.string()
    .required("Project is required")
    .min(3, "Minimum 3 characters")
    .max(100, "Maximum 100 characters"),
  android_bundle: Yup.string()
    .required("Android bundle is required")
    .min(3, "Minimum 3 characters")
    .max(100, "Maximum 100 characters"),
  bucket_url: Yup.string().max(255, "Maximum 255 characters"),
  vendor_id: Yup.string().max(100, "Maximum 100 characters"),
  p8_file: Yup.string().max(1000, "Maximum 1000 characters"),
  key_id: Yup.string().max(100, "Maximum 100 characters"),
  issuer_id: Yup.string().max(100, "Maximum 100 characters"),
  sku: Yup.string()
    .required("SKU is required")
    .max(100, "Maximum 100 characters"),
});

export const useAppForm = (initialValues = null, isEdit = false) => {
  const dispatch = useDispatch();

  const defaultValues = {
    station_name: "",
    app_name: "",
    alias: "",
    Project: "",
    android_bundle: "",
    bucket_url: "",
    vendor_id: "",
    p8_file: "",
    key_id: "",
    issuer_id: "",
    sku: "",
  };

  const formik = useFormik({
    initialValues: initialValues || defaultValues,
    validationSchema,
    enableReinitialize: false,
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      try {
        const payload = { ...values };
        if (isEdit) {
          await dispatch(
            updateApp({ id: initialValues.id, appData: payload })
          ).unwrap();
        } else {
          await dispatch(createApp(payload)).unwrap();
        }
        resetForm();
        return true;
      } catch (error) {
        return false;
      } finally {
        setSubmitting(false);
      }
    },
  });

  useEffect(() => {
    if (isEdit && initialValues) {
      formik.setValues({
        station_name: initialValues.station_name || "",
        app_name: initialValues.app_name || "",
        alias: initialValues.alias || "",
        Project: initialValues.Project || "",
        android_bundle: initialValues.android_bundle || "",
        bucket_url: initialValues.bucket_url || "",
        vendor_id: initialValues.vendor_id || "",
        p8_file: initialValues.p8_file || "",
        key_id: initialValues.key_id || "",
        issuer_id: initialValues.issuer_id || "",
        sku: initialValues.sku || "",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValues, isEdit, formik.setValues]);

  const submitForm = async () => {
    return await formik.submitForm();
  };

  return {
    formik,
    isSubmitting: formik.isSubmitting,
    isValid: formik.isValid,
    dirty: formik.dirty,
    submitForm,
  };
};
